import * as React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc/es5'
import { SessionState } from '@pushly/aqe'

const sanitizePathname = (pathname: string) => pathname.split('?')[0]

const route = (redirectPath: string, props: any) =>
    !redirectPath ? <Route {...props} /> : <Redirect to={redirectPath} exact={true} from={props.path || ''} />

const getSessionState = (): SessionState => Container.get(SessionState)

@observer
export class InternalRoute extends React.Component<any> {
    public render() {
        const sessionState = getSessionState()
        const pathname = sanitizePathname(this.props.location.pathname)

        let redirectPath
        if (!sessionState.isAuthenticated) {
            redirectPath = '/'

            if (pathname !== '/') {
                redirectPath += `?redirect=${location.pathname}`
            }
        }

        return route(redirectPath, this.props)
    }
}

@observer
export class ExternalRoute extends React.Component<any> {
    public render() {
        const sessionState = getSessionState()
        const pathname = sanitizePathname(this.props.location.pathname)
        const queryString = (this.props.location || {}).search

        let redirectPath
        const redirectRequest = queryString.match('redirect=([^&]+)')
        if (sessionState.isAuthenticated) redirectPath = !!redirectRequest ? redirectRequest[1] : '/'

        return route(redirectPath, this.props)
    }
}
